import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { X } from "lucide-react";
import { FALLBACK_GALLERY } from "@/data/static";
import api from "@/lib/api";

export default function Gallery() {
  const [items, setItems] = useState(FALLBACK_GALLERY);
  const [active, setActive] = useState(null);
  useEffect(()=>{ api.get("/gallery").then(({data})=>{ if(data?.length) setItems(data); }).catch(()=>{}); },[]);

  const categories = ["All", ...Array.from(new Set(items.map(i=>i.category)))];
  const [cat, setCat] = useState("All");
  const filtered = cat === "All" ? items : items.filter(i=>i.category===cat);

  return (
    <main className="pt-32 pb-16" data-testid="gallery-page">
      <div className="container-x">
        <motion.div initial={{opacity:0,y:20}} animate={{opacity:1,y:0}} transition={{duration:0.6}}>
          <span className="overline">Gallery</span>
          <h1 className="font-heading text-5xl sm:text-6xl tracking-tight font-light mt-3">Inside our <em className="italic font-medium text-primary">facility</em></h1>
        </motion.div>
        <div className="mt-8 flex flex-wrap gap-2">
          {categories.map(c=>(
            <button key={c} onClick={()=>setCat(c)} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${cat===c?"bg-primary text-white":"bg-slate-100 text-slate-700 hover:bg-slate-200"}`} data-testid={`gallery-cat-${c}`}>{c}</button>
          ))}
        </div>
        <div className="mt-10 columns-1 sm:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
          {filtered.map((g,i)=>(
            <motion.div key={g.id} initial={{opacity:0,y:20}} whileInView={{opacity:1,y:0}} viewport={{once:true}} transition={{duration:0.4,delay:(i%6)*0.05}}
              className="mb-5 break-inside-avoid group cursor-pointer relative rounded-2xl overflow-hidden bg-slate-200"
              onClick={()=>setActive(g)} data-testid={`gallery-item-${i}`}>
              <img src={g.image_url} alt={g.title} className="w-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy"/>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity p-5 flex items-end">
                <div className="text-white">
                  <div className="font-heading">{g.title}</div>
                  <div className="text-xs opacity-80">{g.category}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {active && (
        <div className="fixed inset-0 z-[100] bg-black/85 backdrop-blur flex items-center justify-center p-4" onClick={()=>setActive(null)} data-testid="lightbox">
          <button onClick={()=>setActive(null)} aria-label="Close" className="absolute top-5 right-5 h-11 w-11 rounded-full bg-white/10 text-white flex items-center justify-center"><X className="w-5 h-5"/></button>
          <img src={active.image_url} alt={active.title} className="max-h-[90vh] max-w-[95vw] rounded-2xl"/>
        </div>
      )}
    </main>
  );
}
